import { useMemo } from 'react';
import { useSearchParams } from 'react-router';
import { QUERY_PARAM_DATE, QUERY_PARAM_TENANT } from '@/lib/constants';

/**
 * The `d` and `t` query parameters are read on several pages and have to
 * survive navigation back to the fund list. In Angular each component
 * subscribed to activatedRoute.queryParams separately; here it is one hook.
 */
export function useAppQueryParams() {
  const [searchParams] = useSearchParams();

  return useMemo(() => {
    const activityDate = searchParams.get(QUERY_PARAM_DATE) ?? undefined;
    const tenant = searchParams.get(QUERY_PARAM_TENANT) ?? undefined;

    const preserved = new URLSearchParams();
    if (activityDate) preserved.set(QUERY_PARAM_DATE, activityDate);
    if (tenant) preserved.set(QUERY_PARAM_TENANT, tenant);
    const suffix = preserved.toString();

    return {
      activityDate,
      tenant,
      /** e.g. "/home?d=2026-05-01" */
      withParams: (path: string) => (suffix ? `${path}?${suffix}` : path),
    };
  }, [searchParams]);
}
